module.exports = __webpack_public_path__ + "8cca2f02b0af2da365ff4d1755f29146.ttf";